import { Outlet, NavLink, useNavigate } from "react-router-dom";
import {useEffect, useState} from "react";
import {getProfile} from "../../service/api/apiClient";

const HomeIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
);

const OrderIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
        <rect x="9" y="3" width="6" height="4" rx="2"/>
        <line x1="9" y1="12" x2="15" y2="12"/>
        <line x1="9" y1="16" x2="13" y2="16"/>
    </svg>
);

const SignOutIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
        <polyline points="16 17 21 12 16 7"/>
        <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
);

const ChevronDown = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9"/>
    </svg>
);

const HEADER_CSS = `
    * { box-sizing: border-box; }

    .mh-shell {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        background: #f4f6f9;
        font-family: 'Inter', sans-serif;
    }

    /* ── Top Header ── */
    .mh-header {
        position: sticky;
        top: 0;
        z-index: 1001;
        height: 56px;
        background: #ffffff;
        border-bottom: 1px solid #fff;
        display: flex;
        align-items: center;
        padding: 30px 28px;
        gap: 0;
        box-shadow: 0 2px 12px rgba(141,197,63,0.08);
    }

    /* Brand */
    .mh-brand {
        display: flex;
        align-items: center;
        gap: 9px;
        text-decoration: none;
        margin-right: 32px;
        flex-shrink: 0;
    }

    .mh-brand__icon {
        width: 30px;
        height: 30px;
        background: linear-gradient(135deg, #8dc53f, #6ea832);
        border-radius: 9px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
        font-weight: 800;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(141,197,63,0.3);
    }

    .mh-brand__name {
        font-size: 16px;
        font-weight: 800;
        color: #8dc53f;
        letter-spacing: -0.4px;
        white-space: nowrap;
    }

    /* Nav links */
    .mh-nav {
        display: flex;
        align-items: center;
        gap: 2px;
        flex: 1;
    }

    .mh-nav-item {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        padding: 7px 14px;
        border-radius: 8px;
        color: #64748b;
        text-decoration: none;
        font-size: 14.5px;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
        transition: background 0.15s, color 0.15s;
        white-space: nowrap;
        position: relative;
    }

    .mh-nav-item:hover {
        background: #f4fbe8;
        color: #6ea832;
    }

    .mh-nav-item.active {
        // background: #edf7d6;
        color: #000;
        font-weight: 600;
    }

    /* active underline bar */
    .mh-nav-item.active::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 14px;
        right: 14px;
        height: 2px;
        background: #8dc53f;
        border-radius: 2px 2px 0 0;
    }

    /* Right side of header */
    .mh-header-right {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
    }

    /* User dropdown trigger */
    .mh-user-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 5px 10px 5px 5px;
        border-radius: 10px;
        border: 1px solid #e8f5d0;
        // background: #f9fef2;
        cursor: pointer;
        transition: all 0.15s;
        position: relative;
    }

    .mh-user-btn:hover {
        // border-color: #c5e87a;
        // background: #f2fce0;
    }

    .mh-user-btn.open {
        // border-color: #8dc53f;
        box-shadow: 0 0 0 3px rgba(141,197,63,0.12);
        background: #fff;
    }

    .mh-user__avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: linear-gradient(135deg, #8dc53f, #6ea832);
        color: #000;
        font-size: 11px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        font-family: 'Inter', sans-serif;
    }

    .mh-user__name {
        font-size: 13px;
        font-weight: 600;
        color: #1a1a1a;
        font-family: 'Inter', sans-serif;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .mh-user__chevron {
        color: #94a3b8;
        transition: transform 0.2s;
        display: flex;
    }

    .mh-user-btn.open .mh-user__chevron {
        transform: rotate(180deg);
    }

    /* Dropdown */
    .mh-dropdown {
        position: absolute;
        top: calc(100% + 8px);
        right: 0;
        min-width: 200px;
        background: #fff;
        border: 1px solid #e8f5d0;
        border-radius: 12px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.10), 0 2px 8px rgba(141,197,63,0.08);
        overflow: hidden;
        animation: mh-drop 0.14s ease;
        z-index: 999;
    }

    @keyframes mh-drop {
        from { opacity: 0; transform: translateY(-6px) scale(0.98); }
        to   { opacity: 1; transform: translateY(0) scale(1); }
    }

    .mh-dropdown__header {
        padding: 12px 16px;
        border-bottom: 1px solid #f0fae0;
        background: #f9fef2;
    }

    .mh-dropdown__name {
        font-size: 13px;
        font-weight: 700;
        color: #1a1a1a;
        font-family: 'Inter', sans-serif;
    }

    .mh-dropdown__role {
        font-size: 11px;
        color: #94a3b8;
        margin-top: 2px;
        font-family: 'Inter', sans-serif;
    }

    .mh-dropdown__item {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 10px 16px;
        border: none;
        background: transparent;
        font-size: 13px;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
        color: #475569;
        cursor: pointer;
        transition: background 0.12s, color 0.12s;
        text-align: left;
    }

    .mh-dropdown__item:hover {
        background: #fef2f2;
        color: #ef4444;
    }

    /* ── Main content ── */
    .mh-main {
        flex: 1;
    }

    /* ── Responsive ── */
    @media (max-width: 640px) {
        .mh-header {
            padding: 0 14px;
        }

        .mh-brand {
            margin-right: 16px;
        }

        .mh-brand__name {
            display: none;
        }

        .mh-nav-item span:last-child {
            display: none;
        }

        .mh-nav-item {
            padding: 7px 10px;
        }

        .mh-user__name {
            display: none;
        }
    }
`;


// Example helper (you can move this to utils)

export const MainHeader = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    // Get user safely
    const profile = getProfile();
    const user = profile?.user || {};
    const role = profile?.roles?.[0] || "Admin";

    // Create initials
    const initials = user?.name
        ? user.name
            .split(" ")
            .map((w) => w[0])
            .join("")
            .slice(0, 2)
            .toUpperCase()
        : "U";

    const handleSignOut = () => {
        localStorage.clear(); // better than clear()
        navigate("/signin");
    };

    // Close dropdown on outside click
    useEffect(() => {
        if (!open) return;

        const handler = (e) => {
            if (
                !e.target.closest(".mh-user-btn") &&
                !e.target.closest(".mh-dropdown")
            ) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [open]);

    return (
        <>
            <style>{HEADER_CSS}</style>

            <div className="mh-shell">

                <header className="mh-header">
                    <a href="/" className="mh-brand">
                        <img
                            alt="Logo"
                            src="https://food.totalfresh.co/assets/img/logos/logo.png"
                            style={{ width: 135, height: 40 }}
                        />
                    </a>

                    {/* Nav */}
                    <nav className="mh-nav">
                        <NavLink
                            to="/"
                            end
                            className={({ isActive }) =>
                                `mh-nav-item${isActive ? " active" : ""}`
                            }
                        >
                            <HomeIcon />
                            <span>Home</span>
                        </NavLink>

                        <NavLink
                            to="/orders"
                            className={({ isActive }) =>
                                `mh-nav-item${isActive ? " active" : ""}`
                            }
                        >
                            <OrderIcon />
                            <span>Orders</span>
                        </NavLink>

                        {/*<NavLink*/}
                        {/*    to="/admin"*/}
                        {/*    className={({ isActive }) =>*/}
                        {/*        `mh-nav-item${isActive ? " active" : ""}`*/}
                        {/*    }*/}
                        {/*>*/}
                        {/*    <OrderIcon />*/}
                        {/*    <span>Admin</span>*/}
                        {/*</NavLink>*/}
                    </nav>

                    {/* Right: user dropdown */}
                    <div className="mh-header-right">
                        <div style={{ position: "relative" }}>
                            <button
                                className={`mh-user-btn${open ? " open" : ""}`}
                                onClick={() => setOpen((o) => !o)}
                            >
                                <div className="mh-user__avatar">
                                    {initials}
                                </div>
                                <span className="mh-user__name">
                                    {user.name || "User"}
                                </span>
                                <span className="mh-user__chevron">
                                    <ChevronDown />
                                </span>
                            </button>

                            {open && (
                                <div className="mh-dropdown">
                                    <div className="mh-dropdown__header">
                                        <div className="mh-dropdown__name">
                                            {user.name || "User"}
                                        </div>
                                        <div className="mh-dropdown__role">
                                            {role}
                                        </div>
                                    </div>

                                    <button
                                        className="mh-dropdown__item"
                                        onClick={handleSignOut}
                                    >
                                        <SignOutIcon /> Sign Out
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                {/* ── Page content ── */}
                <main className="mh-main">
                    <Outlet />
                </main>
            </div>
        </>
    );
};